import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const FIELD_TECHS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('FIELD_TECHS');
export const FIELD_TECHS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	FIELD_TECHS_CRUD_ACTION_CONSTANTS
);
